import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Tooltip, Button, Select, Input, Table, Modal, message } from 'antd'
import { req_page_ccw_courseOutline, req_delete_ccw_courseOutline } from '../../api'
import memoryUtils from '../../utils/memoryUtils'
import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'

import { usrRole } from '../../utils/dataUtil'
import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'

import AddModal from './object-course-add-modal'

class ObjectCourseList extends Component {

    state = {
        loading: false,
        deviceWidth: 0,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'NONE',
        searchValue: '',
        filterStatus: '',

        domnloadFile: '',

        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),

        isShowModal: false,
        isEditModal: false,
        isAddModal: false,
    }

    UNSAFE_componentWillMount() {
        window.removeEventListener("resize", this.resize.bind(this));

        this.init_columns()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        this.api_page_items(1)
    }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_page_items = (current) => {
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, userCode, role } = this.props.user
        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        //採用(母母視窗模式)
        if (memoryUtils.pagination.isGoBack) {
            // 標準
            this.current = memoryUtils.pagination.current
            const pageSize = memoryUtils.pagination.pageSize
            const columnSort = memoryUtils.pagination.columnSort
            const orderBy = memoryUtils.pagination.orderBy
            const searchField = memoryUtils.pagination.searchField
            const searchValue = memoryUtils.pagination.searchValue
            const filterStatus = memoryUtils.pagination.filterStatus
            this.setState({
                current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus
            }, () => {
                this.api_page_run(userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
            })
        } else {
            this.current = current // 保存當前頁，給其他方法可看到
            this.api_page_run(userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        }

        if (memoryUtils.pagination.isGoBack) {
            memoryUtils.pagination.isGoBack = false
        }
    }

    api_page_run = async (userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token) => {
        this.setState({ loading: true, items: [] })
        const result = await req_page_ccw_courseOutline(userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        //console.log(result);
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })

        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
        this.setState({ loading: false })
    }

    api_delete_item = async (key) => {
        const { token } = this.props.user
        const result = await req_delete_ccw_courseOutline(key, token)

        if (result.status === 'success') {
            message.success('刪除成功')
            this.api_page_items(this.current)
        } else {
            //console.log(result)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '學年/期',
                width: 20,
                responsive: ['md'],
                render: (item) => {
                    const { AcademicYear, AcademicSemester } = item
                    return (
                        <>{AcademicYear}/{AcademicSemester}</>
                    )
                },

            },
            {
                title: '開課流水號',
                responsive: ['md'],
                dataIndex: 'OpenCourseIdKey',
                width: 20,
            },
            {
                title: '課程名稱',
                dataIndex: 'OpenCourseTwName',
                width: 80,
            },
            {
                title: '老師職號',
                responsive: ['md'],
                dataIndex: 'CourseTeacherId',
                width: 30,
            },
            {
                title: '老師姓名',
                responsive: ['md'],
                dataIndex: 'CourseTeacherName',
                width: 30,
            },
            {
                title: '人數',
                responsive: ['md'],
                dataIndex: 'StudentTotal',
                width: 20,
            },
            {
                title: '',
                dataIndex: '',
                width: 50,
                render: (item) => {
                    return (
                        <>
                            <button type="button" className="btn btn-outline-dark btn-sm" onClick={() => this.handle_show_ui_modal('view', item)}><i className="fas fa-user-friends"></i><span style={{ marginLeft: '2px' }}>  學生清單</span></button>
                            <button type="button" className="btn btn-outline-dark btn-sm" onClick={() => this.handle_show_ui_modal('delete', item)}><i className="fas fa-minus-square"></i><span style={{ marginLeft: '2px' }}>   刪除</span></button>

                        </>
                    )
                },

            },
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    handle_show_ui_modal = (modal, item) => {
        switch (modal) {
            case 'view':
                const { nowAcademicYear, nowAcademicSemester, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus } = this.state
                memoryUtils.pagination.academicYear = nowAcademicYear
                memoryUtils.pagination.academicSemester = nowAcademicSemester
        
                memoryUtils.pagination.current = this.current
                memoryUtils.pagination.pageSize = pageSize
                memoryUtils.pagination.columnSort = columnSort
                memoryUtils.pagination.orderBy = orderBy
                memoryUtils.pagination.searchField = searchField
                memoryUtils.pagination.searchValue = searchValue
                memoryUtils.pagination.filterStatus = filterStatus
        
                this.props.history.push('/culturalcreativeworks/course/students', item)
                break;
            case 'edit':
                this.setState({ isEditModal: true, item })
                break;
            case 'add':
                this.setState({ isAddModal: true })
                break;
            case 'delete':
                const { OpenCourseIdKey } = item
                Modal.confirm({
                    title: `您確定刪除此課程數據`,
                    onOk: () => {
                        this.api_delete_item(OpenCourseIdKey)
                    }
                })
                break;
            case 'download':

                break;
            default:
        }
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { loading, items, pagination, searchField, searchValue, isAddModal } = this.state
        const title = (
            <>
                <Select value={searchField} style={{ width: 120, backgroundColor: 'LightCyan' }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='NONE'>搜索條件</Select.Option>
                    <Select.Option value='OpenCourseTwName'>課程名稱</Select.Option>
                    <Select.Option value='CourseTeacherName'>課程老師名稱</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 80, margin: '0 5px', backgroundColor: 'LightYellow' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i><span style={{ marginLeft: '4px' }}>查詢</span></Button>
                {' '}
                <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
                {' '}
                <Button type='primary' onClick={() => this.handle_show_ui_modal('add', {})}><i className="fas fa-plus"></i><span style={{ marginLeft: '4px' }}>增加</span></Button>
                <p />
            </>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='Uid'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        position: ['topRight'],
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    visible={isAddModal}
                    width={800}
                    onOk={() => {
                        this.setState({ isAddModal: false })
                        this.handle_data_refresh()
                    }}
                    okText={'關閉'}
                    onCancel={() => {
                        this.setState({ isAddModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <AddModal />
                </Modal>
            </Card>
        )

    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ObjectCourseList)